
import { mapState } from "pinia";
import { BNavItemDropdown } from "bootstrap-vue";
import { defineComponent } from "vue";
import MapGroupController from "@/components/drawers/right/MapGroupController.vue";
import MapLayerController from "@/components/drawers/right/MapLayerController.vue";
import { IBaseMap, MapLayerGroup } from "@/types";
import { LayerControl } from "@/types/LayerControl";
import { useMap } from "@/services";

export default defineComponent({
  name: "MapMasterController",
  components: {
    MapGroupController,
    MapLayerController,
  },
  computed: {
    ...mapState(useMap, ["baseMap", "baseMaps"]),
    layerGroups(): MapLayerGroup[] {
      return (useMap().layerGroups as MapLayerGroup[]).filter(
        (g) => !g.parents.length
      );
    },
    activeLayers(): LayerControl[] {
      return (useMap().layerControls as LayerControl[]).filter(
        (l) => l.isVisible
      );
    },
  },
  methods: {
    selectBaseMap(index: number): void {
      if (this.$router.currentRoute.path !== "/") {
        this.$router.push("/");
      }
      const mapStore = useMap();
      mapStore.activeLayers.forEach((layer: LayerControl) => {
        mapStore.setLayerVilisbity(layer.id, layer.isVisible);
      });
      mapStore.baseMapIndex = index;
    },
    isCurrentBaseMap(map: IBaseMap): boolean {
      return this.baseMap.name === map.name;
    },
    closeMenu(ref: string) {
      const menu = this.$refs[ref];
      if (menu instanceof BNavItemDropdown) {
        menu.hide(true);
      }
    },
  },
});
